import React from 'react';
import { TeamPermission } from 'nekst-api';
import EmailDomainsListBlock from './EmailDomainsListBlock';
import AccessChecker from '../../shared/authorization/AccessChecker';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';

export default function EmailConfigurationPage() {
  return (
    <AccessChecker permissionToCheck={TeamPermission.MANAGE_EMAIL_CONFIGURATION}>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Email Domain Setup" />
      </SettingsBreadcrumbs>
      <EmailDomainsListBlock />
    </AccessChecker>
  );
}
